import {FC, memo} from 'react';
import {useTrackAbTest} from '../../trackingHooks/trackAbTest';

/**
 * Tracks AB test group assignments on mount.
 * customer_data tracking has been merged into TrackContentPageView
 * to fire immediately after content_view without polling delay.
 */
const TrackCustomer: FC = () => {
  useTrackAbTest();
  return null;
};

const MemoizedTrackCustomer = memo(TrackCustomer);

export {MemoizedTrackCustomer as TrackCustomer};
